// extracted by mini-css-extract-plugin
export default {"formSection":"FormSection_formSection__TDK-j","title":"FormSection_title__Bxlv-"};